// == Unichat Extension ==
// Funções de API para endpoints Unichat
// Usa window.axios do Chatwoot (configurado com DeviseTokenAuth headers em dashboard.js)

const http = () => window.axios;

const BASE = accountId => `/api/v1/unichat/accounts/${accountId}`;

export const getSectors = accountId =>
  http().get(`${BASE(accountId)}/sectors`);

export const getSector = (accountId, sectorId) =>
  http().get(`${BASE(accountId)}/sectors/${sectorId}`);

export const createSector = (accountId, payload) =>
  http().post(`${BASE(accountId)}/sectors`, { sector: payload });

export const updateSector = (accountId, sectorId, payload) =>
  http().patch(`${BASE(accountId)}/sectors/${sectorId}`, { sector: payload });

export const deleteSector = (accountId, sectorId) =>
  http().delete(`${BASE(accountId)}/sectors/${sectorId}`);

export const getSectorAgents = (accountId, sectorId) =>
  http().get(`${BASE(accountId)}/sectors/${sectorId}/sector_agents`);

export const addSectorAgent = (accountId, sectorId, agentId) =>
  http().post(`${BASE(accountId)}/sectors/${sectorId}/sector_agents`, { agent_id: agentId });

export const removeSectorAgent = (accountId, sectorId, agentId) =>
  http().delete(`${BASE(accountId)}/sectors/${sectorId}/sector_agents/${agentId}`);

export const getSectorTeams = (accountId, sectorId) =>
  http().get(`${BASE(accountId)}/sectors/${sectorId}/sector_teams`);

export const addSectorTeam = (accountId, sectorId, teamId) =>
  http().post(`${BASE(accountId)}/sectors/${sectorId}/sector_teams`, { team_id: teamId });

export const removeSectorTeam = (accountId, sectorId, teamId) =>
  http().delete(`${BASE(accountId)}/sectors/${sectorId}/sector_teams/${teamId}`);

export const getVisibility = accountId =>
  http().get(`${BASE(accountId)}/visibility`);

export const transferToSector = (accountId, conversationId, sectorId) =>
  http().post(
    `${BASE(accountId)}/conversations/${conversationId}/transfer_to_sector`,
    { sector_id: sectorId }
  );

export const transferToTeam = (accountId, conversationId, teamId, sectorId) =>
  http().post(
    `${BASE(accountId)}/conversations/${conversationId}/transfer_to_team`,
    { team_id: teamId, sector_id: sectorId }
  );

export const getTransferHistory = (accountId, conversationId) =>
  http().get(`${BASE(accountId)}/conversations/${conversationId}/transfer_history`);

export const getConversationUnichat = (accountId, conversationId) =>
  http().get(`${BASE(accountId)}/conversations/${conversationId}`);

export const getAgentAssignments = accountId =>
  http().get(`${BASE(accountId)}/agent_assignments`);

export const getPendingAgents = accountId =>
  http().get(`${BASE(accountId)}/pending_agents`);

export const approvePendingAgent = (accountId, userId, payload) =>
  http().post(`${BASE(accountId)}/pending_agents/${userId}/approve`, payload);

export const rejectPendingAgent = (accountId, userId) =>
  http().delete(`${BASE(accountId)}/pending_agents/${userId}`);

export const publicRegister = payload =>
  window.axios.post('/api/v1/unichat/public/register', payload);

// Aparência da marca (logos / favicon) — somente admin
export const getBranding = accountId =>
  http().get(`${BASE(accountId)}/branding`);

export const updateBranding = (accountId, formData) =>
  // Não definir Content-Type manualmente: o axios precisa gerar o boundary
  // do multipart automaticamente a partir do FormData.
  http().patch(`${BASE(accountId)}/branding`, formData);

export const deleteBrandingAsset = (accountId, asset) =>
  http().delete(`${BASE(accountId)}/branding`, { data: { asset } });

// Chat do Setor — canal único por Setor (Team)
export const getMySectorChats = accountId =>
  http().get(`${BASE(accountId)}/sector_chats`);

export const getSectorChatMessages = (accountId, teamId) =>
  http().get(`${BASE(accountId)}/sector_chats/${teamId}/messages`);

export const createSectorChatMessage = (accountId, teamId, content) =>
  http().post(`${BASE(accountId)}/sector_chats/${teamId}/messages`, { content });
